import React from 'react';
import { useSearchParams } from 'react-router';
import { Box, Typography, Button } from '@mui/material';
import AiInsightsLogo from '../components/layout/AiInsightsLogo';
import config from '../config';

/**
 * Entry point for iframe embedding that provides a button to launch the full application.
 * Passes JWT from URL parameters to the authentication page when opened.
 *
 * @returns {React.FC}
 */
const IframePage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const jwt = searchParams.get('jwt');
    const authUrl = jwt ? `${config.baseUrl}/auth?jwt=${jwt}` : null;

    const handleOpenAuth = () => {
        if (authUrl) {
            window.open(authUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh" p={3}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    textDecoration: 'none',
                    mb: 1.5,
                }}
            >
                <Box sx={{ width: 24, height: 24, ml: 0.15 }}>
                    <AiInsightsLogo variant="primary" />
                </Box>
                <Typography variant="h3" sx={{ fontWeight: 'bold', ml: 0.75, color: 'primary.main' }}>
                    AI Insights
                </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
                <Button variant="contained" color="primary" onClick={handleOpenAuth} fullWidth disabled={!jwt}>
                    Continue to AI Insights
                </Button>
                <Typography variant="body2" color="text.secondary" mt={0.5}>
                    {authUrl ? 'Opens in new window' : 'JWT authentication token is missing'}
                </Typography>
            </Box>
        </Box>
    );
};

export default IframePage;
